module.exports = __webpack_public_path__ + "static/assets/cee418c6e4a906d67ce7d4879d020ee4.png";